import React from 'react';
import { GiFairyWings } from 'react-icons/gi';
import { Helmet } from "react-helmet-async";
import './ScholarshipProcedure.css';

const ScholarshipProcedure = () => {
  return (
    <>
      <Helmet>
        <title>Scholarship Procedure | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Scholarship procedure for Rajput Shiksha Kosh, outlining the steps and criteria for applying for educational scholarships."
        />
      </Helmet>
    <section className="scholarship-procedure-wrapper">
      <div className="scholarship-procedure-container">
        
        {/* --- MAIN HEADER --- */}
        <div className="scholarship-procedure-header">
          <h1 className="scholarship-procedure-main-title">PRATIBHA KHOJ DETAILS</h1>
          <div className="scholarship-procedure-divider">
            <span className="scholarship-procedure-line"></span>
            <GiFairyWings className="scholarship-procedure-icon" />
            <span className="scholarship-procedure-line"></span>
          </div>
        </div>

        {/* --- SUBTITLE --- */}
        <h2 className="scholarship-procedure-sub-title">
          Scholarship Procedure
        </h2>

        {/* --- MAIN CONTENT CARD --- */}
        <div className="scholarship-procedure-content-card">
          <p className="scholarship-procedure-intro-text">
            छात्रवृतियां दो भागों में विभक्त होगी |
          </p>

          <div className="scholarship-procedure-section">
            <h3 className="scholarship-procedure-section-heading">१. उच्च शिक्षा वर्ग</h3>
            <ul className="scholarship-procedure-list">
              <li>(अ) प्रोफेशनल कोर्सेस के लिए कोचिंग हेतु |</li>
              <li>(ब) हायर प्रोफेशनल शिक्षा हेतु |</li>
            </ul>
            <p className="scholarship-procedure-paragraph">
              उच्च शिक्षा वर्ग हेतु प्रोफेसर डॉ कल्याणसिंह जी शेखावत के संयोजकत्द में प्रो. डॉ. गोविंदसिंह जी , प्रो. डॉ. गुलाबसिंह जी चौहान , प्रो. डॉ. प्रतापसिंह जी भाटी , प्रो. महेंद्रसिंह जी राठौर तथा प्रो. डूंगरसिंह जी खींची की एक समिति का गठन किया गया है |
            </p>
          </div>

          <div className="scholarship-procedure-section">
            <h3 className="scholarship-procedure-section-heading">२. माध्यमिक एवं उच्च माध्यमिक शिक्षा वर्ग :</h3>
            <p className="scholarship-procedure-paragraph">
              इसी प्रकार सेकेंडरी शिक्षा के लिए श्री श्याम सिंह जी सजाड़ा के संयोजकत्द में पांच प्रिंसिपलों की एक कमेठी गठित की गई है | जो समिति प्रतिभा खोज परीक्षा करके अभावग्रस्त जरूरतमंद बालकों को छात्रवृतियां देने की सिफारिश करेगी |
            </p>
          </div>

          <div className="scholarship-procedure-conclusion">
            <p>
              उपरोक्त समितयों की सिफारिश पर उनके द्धारा अनुमोदित रकम का चैक सम्बंधित शिक्षा संस्थान जहाँ वह बच्चा अध्यन्न चाहता है को प्रेक्षित कर दिया जायेगा |
            </p>
          </div>
        </div>
        
      </div>
    </section>
    </>
  );
};

export default ScholarshipProcedure;